import { render } from "./FakeNewsQuestion.component.vue?vue&type=template&id=f2f3f45e"
import script from "./FakeNewsQuestion.component.vue?vue&type=script&lang=js"
export * from "./FakeNewsQuestion.component.vue?vue&type=script&lang=js"

import exportComponent from "/builds/ASIP-Sante/g1/shared/santefr/web/modules/custom/sante_vuejs/vue-core/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/sharedComponents/FakeNewsQuestion.component.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f2f3f45e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f2f3f45e', __exports__)) {
    console.log('reload')
    api.reload('f2f3f45e', __exports__)
  }
  
  module.hot.accept("./FakeNewsQuestion.component.vue?vue&type=template&id=f2f3f45e", () => {
    console.log('re-render')
    api.rerender('f2f3f45e', render)
  })

}


export default __exports__